import React from "react";
import {
  Typography,
  Backdrop,
  Fade,
  Box,
  Modal,
  Button,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Grid,
} from "@mui/material";
import useStyles from "./styles";
// import { color } from "../../Config/theme";

function ConfirmDialog(props) {
  const {
    visible = false,
    handleModal = () => null,
    title = "",
    btnLoad = false,
    subTitle = "",
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: md ? 300 : 600,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={visible}
      closeAfterTransition
      disableAutoFocus
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={visible}>
        <Box sx={style}>
          <Grid container>
            <Typography className={classes.modalTitle}>
              {title || ""}
            </Typography>
          </Grid>
          {subTitle !== "" && (
            <Grid container>
              <Typography
                variant="caption"
                style={{ marginBottom: 20, fontSize: 14 }}
              >
                <b>Note: </b> {subTitle || ""}
              </Typography>
            </Grid>
          )}
          <div
            className={classes.splitViewStyle}
            style={{ justifyContent: "unset" }}
          >
            <Button
              variant="outlined"
              className={classes.modalBtnStyle}
              fullWidth
              onClick={() => {
                if (handleModal) {
                  handleModal();
                }
              }}
              disabled={btnLoad}
            >
              No
            </Button>
            <div style={{ width: 50 }} />
            <Button
              variant={"outlined"}
              color="primary"
              className={classes.modalBtnStyle}
              fullWidth
              onClick={() => {
                if (handleModal) {
                  handleModal(true);
                }
              }}
              disabled={btnLoad ? true : false}
            >
              {btnLoad ? <CircularProgress size={28} /> : "Yes"}
            </Button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ConfirmDialog;
